import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect';
import 'alpine-turbo-drive-adapter';

// Initialize Alpine plugins
Alpine.plugin(focus);
Alpine.plugin(persist);
Alpine.plugin(intersect);

// Define the global Alpine.js store
document.addEventListener('alpine:init', () => {
    Alpine.store('app', {
        // Global state properties
        darkModeEnabled: Alpine.$persist(true).as('darkMode'),
        sidebarOpen: Alpine.$persist(window.innerWidth >= 1024).as('sidebarOpen'),

        // Initializer function, runs when the store is created
        init() {
            this.updateDarkMode();
            
            // Watch for changes in sidebarOpen to add/remove body class
            // Add guard to prevent infinite loops
            let lastSidebarState = this.sidebarOpen;
            let lastWindowWidth = window.innerWidth;
            
            Alpine.effect(() => {
                const currentWidth = window.innerWidth;
                const currentSidebar = this.sidebarOpen;
                
                // Only update if something actually changed
                if (currentSidebar !== lastSidebarState || currentWidth !== lastWindowWidth) {
                    if (currentSidebar && currentWidth < 1024) {
                        document.body.classList.add('overflow-hidden');
                    } else {
                        document.body.classList.remove('overflow-hidden');
                    }
                    
                    lastSidebarState = currentSidebar;
                    lastWindowWidth = currentWidth;
                }
            });
        },

        // Toggles dark mode and updates the DOM
        toggleDarkMode() {
            this.darkModeEnabled = !this.darkModeEnabled;
            this.updateDarkMode();
        },

        // Applies or removes the 'dark' class from the HTML element
        updateDarkMode() {
            if (this.darkModeEnabled) {
                document.documentElement.classList.add('dark');
            } else {
                document.documentElement.classList.remove('dark');
            }
        },

        // Toggles the sidebar state
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen;
        },
        
        // Check if current page matches the given URL
        isCurrentPage(url) {
            const currentPath = window.location.pathname;
            return currentPath === url || currentPath.startsWith(url + '/');
        }
    });
});

// Fallback for isCurrentPage if Alpine store is not available
if (typeof window !== 'undefined') {
    window.isCurrentPage = window.isCurrentPage || function(url) {
        const currentPath = window.location.pathname;
        return currentPath === url || currentPath.startsWith(url + '/');
    };
}

// Expose Alpine globally but don't start it yet
window.Alpine = Alpine;

// Expose Alpine globally for debugging
if (window.location.hostname === 'localhost') {
    window.Alpine = Alpine;
}

// Wait for other scripts to register their components, then start Alpine
document.addEventListener('DOMContentLoaded', () => {
    // Allow a small delay for other scripts to register their components
    setTimeout(() => {
        if (!Alpine._x_isInitialized) {
            Alpine.start();
            
            // Initialize the app store after Alpine has started
            setTimeout(() => {
                if (Alpine.store('app') && Alpine.store('app').init) {
                    Alpine.store('app').init();
                }
            }, 10);
        }
    }, 10);
});

// Handle Turbo Drive events
document.addEventListener('turbo:load', () => {
    // Re-initialize components when navigating with Turbo
    setTimeout(() => {
        if (Alpine.store('app') && Alpine.store('app').init) {
            Alpine.store('app').init();
        }
    }, 10);
});
